import * as actionTypes from './actionTypes'

const initialState = { 
  coupon: false, 
} 
const reducer =  (state = initialState, action) => {
    switch (action.type) { 
        case actionTypes.SET_COUPON:
            return {...state,coupon: action.payload}
        default:
            return state
    }
}

export default reducer;